import passengersSaga from './passengersSaga';

export default passengersSaga;
